import { RJSFSchema } from '@rjsf/utils'

export const isEmptySchema = (schema?: RJSFSchema): boolean => {
    if (!schema) {
        return true
    }

    const isObjectType = schema.type === 'object'

    const hasNoProperties = !schema.properties
    const hasEmptyProperties = Object.keys(schema.properties ?? {}).length === 0

    return isObjectType && (hasNoProperties || hasEmptyProperties)
}
